import { Injectable, Injector, Type } from '@angular/core';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import * as StackTraceParser from 'error-stack-parser';
import * as Sentry from '@sentry/browser';
import { User } from '../shared/shared.type';

@Injectable()
export class ErrorsService {
  constructor (
    private injector: Injector
  ) {}

  /**
   * Logging error to console and Sentry
   * @name log
   * @param error
   */
  log (error: Error | HttpErrorResponse) {
    // Check if sentry has been initialized
    if (Sentry.getCurrentHub()
              .getClient()) {
      // Send error to Sentry
      Sentry.captureException(error);
    } else {
      console.error('Please initialize Sentry by calling Sentry.init()');
    }

    // Log the error to the console
    console.error(error);
  }

  /**
   * Add extra info about error
   * @param error
   * @returns returns an object representing error with context
   */
  addContextInfo (error: Error | HttpErrorResponse) {
    // You can include context details here (usually coming from other services: UserService...)
    const name     = error.name || null;
    const time     = new Date();
    const user     = (<any>window).login && ((<any>window).login.user as User).facebook_name;
    const location = this.injector.get<LocationStrategy>(LocationStrategy as Type<LocationStrategy>);
    const url      = location instanceof PathLocationStrategy ? location.path() : '';
    const status   = (<HttpErrorResponse>error).status || null;
    const message  = error.message || error.toString();
    const stack    = error instanceof HttpErrorResponse ? null : StackTraceParser.parse.call(StackTraceParser, error);

    return {name, user, time, url, status, message, stack};
  }
}
